import { EmailValidation } from '@core/mailbox-types';
import {
  createEntityCollectionStore,
  DEFAULT_SCOPE_NAME,
  getEntityCollectionActions,
  pipeState,
} from '@core/ngrx-legacy';
const { actions, reducer, namespace, selectors } = createEntityCollectionStore<EmailValidation>()(
  'email-validation',
  {
    idSelector: (entity: { email: string }) => entity.email,
    customActions: adapter => {
      const selectId = ({ email }: EmailValidation) => email;
      const defaultActions = getEntityCollectionActions(adapter, selectId);

      return {
        validate: (state, payload: { params: string[]; scope: string }) =>
          defaultActions.fetchCollection(state, payload),
        validateSuccess: (state, payload: { data: EmailValidation[]; scope: string }) =>
          pipeState(
            state,
            next => adapter.upsertMany(next, payload.data, { scope: payload.scope }),
            next =>
              adapter.markAsLoaded(next, {
                scope: payload.scope || DEFAULT_SCOPE_NAME,
                entities: payload.data.map(e => e.email),
              }),
          ),
        validateFailed: defaultActions.fetchCollectionFailed,
      };
    },
  },
);

export {
  actions as EmailValidationActions,
  reducer as EmailValidationsReducer,
  namespace as EmailValidationsNamespace,
  selectors as EmailValidationsSelectors,
};
